// extracted by mini-css-extract-plugin
export default {"doc-page-wrapper":"q_bq container-lg d-flex p-3","doc-page":"q_br","doc-page__title--enterprise":"q_bs","doc-page--with-side-menu":"q_bt","doc-page__title":"q_bv"};